export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00884.d9a86b4f.png";